export enum Progress {
    NotStarted = 0,
    Running = 1,
    Success = 2,
    Failed = 3,
    Aborted = 4,
    NotStartedMissingId = 90,
    RunningMissingId = 91,
    SuccessMissingId = 92,
    FailedMissingId = 93,
    AbortedMissingId = 94,
}
